import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const MonitoringPage = lazy(() => import('@cobliteam/monitoring/src/pages/MonitoringPage'));

const routes = [
  {
    title: locationName[Location.MONITORING],
    path: Location.MONITORING,
    component: MonitoringPage,
    needsGoogleMaps: true,
  },
];

export default routes;
